import { cloneElement, isValidElement, useMemo } from 'react';

import {
  defaultContextValue,
  SCROLL_OBSERVER_ROOT_ID,
  ScrollObserverRootProvider,
} from '@kc-console/context';
import { getUuid } from '@kc-console/core';

import type { ReactElement } from 'react';
import type {
  ScrollObserverRootContextState,
  ScrollObserverRootIdProps,
} from '@kc-console/context';

type ScrollObserverRootWrapperProps = Partial<ScrollObserverRootContextState> & {
  rootComponent: ReactElement;
};

const ScrollObserverRootWrapper = (props: ScrollObserverRootWrapperProps) => {
  const { rootComponent, rootId: rootIdProp, ...stateProp } = props;

  const uuid = useMemo(() => getUuid(), []);
  const rootId = useMemo(() => rootIdProp || uuid, [rootIdProp, uuid]);

  const state = useMemo(() => {
    return {
      ...defaultContextValue,
      ...stateProp,
      rootId,
    };
  }, [rootId, stateProp]);

  const element = isValidElement<typeof rootComponent & ScrollObserverRootIdProps>(rootComponent)
    ? cloneElement(rootComponent, {
        ...rootComponent.props,
        [SCROLL_OBSERVER_ROOT_ID]: state.rootId,
      })
    : rootComponent;

  return <ScrollObserverRootProvider {...state}>{element}</ScrollObserverRootProvider>;
};

export default ScrollObserverRootWrapper;
